// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");

function container(isShowing) {
  return Curry._1(BrowserStyle.merge, {
              hd: "poop-mc-stupid-pants",
              tl: {
                hd: Curry._1(BrowserStyle.style, {
                      hd: BrowserStyle.backgroundColor({
                            TAG: /* White */7,
                            _0: /* Light */2
                          }),
                      tl: {
                        hd: BrowserStyle.position("fixed"),
                        tl: {
                          hd: BrowserStyle.top(BrowserStyle.px(0)),
                          tl: {
                            hd: BrowserStyle.left(isShowing ? BrowserStyle.px(0) : BrowserStyle.vw(-80.0)),
                            tl: {
                              hd: BrowserStyle.bottom(BrowserStyle.px(0)),
                              tl: {
                                hd: BrowserStyle.right(isShowing ? BrowserStyle.vw(20.0) : BrowserStyle.vw(100.0)),
                                tl: {
                                  hd: BrowserStyle.width(BrowserStyle.vw(80.0)),
                                  tl: {
                                    hd: BrowserStyle.transition(500, 0, "easeInOut", "right"),
                                    tl: {
                                      hd: BrowserStyle.transition(500, 0, "easeInOut", "left"),
                                      tl: {
                                        hd: BrowserStyle.zIndex(20),
                                        tl: {
                                          hd: BrowserStyle.overflowY("scroll"),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }),
                tl: /* [] */0
              }
            });
}

var Styles = {
  container: container
};

function BrowserComponents_MobilePopoutMenu(Props) {
  var isShowing = Props.isShowing;
  var children = Props.children;
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container(isShowing),
              children: children
            });
}

var make = BrowserComponents_MobilePopoutMenu;

exports.Styles = Styles;
exports.make = make;
/* react Not a pure module */
